// @ts-nocheck
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { LogoLibraryProvider } from './LogoLibraryProvider';
import LogoLibraryDataTable from './LogoLibraryDataTable';
import LogoLibraryActions from './LogoLibraryActions';
import withDashboardActions from '@/containers/Dashboard/withDashboardActions';
import { compose } from '@/utils';

function LogoLibraryList({ changePreferencesPageTitle }) {
  useEffect(() => {
    changePreferencesPageTitle('Logo Library');
  }, [changePreferencesPageTitle]);

  return (
    <LogoLibraryProvider>
      <LogoLibraryDataTable />
    </LogoLibraryProvider>
  );
}

export default compose(withDashboardActions)(LogoLibraryList);

const ActionsBar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 16px;
  border-bottom: 1px solid #e0e0e0;
`;
